export const FETCH_SHIFTS = "FETCH_SHIFTS";
export const FETCH_SHIFTS_SUCCESS = "FETCH_SHIFTS_SUCCESS";
export const FETCH_SHIFTS_FAILURE = "FETCH_SHIFTS_FAILURE";

export const CREATE_SHIFT = "CREATE_SHIFT";
export const CREATE_SHIFT_SUCCESS = "CREATE_SHIFT_SUCCESS";
export const CREATE_SHIFT_FAILURE = "CREATE_SHIFT_FAILURE";

export const UPDATE_SHIFT = "UPDATE_SHIFT";
export const UPDATE_SHIFT_SUCCESS = "UPDATE_SHIFT_SUCCESS";
export const UPDATE_SHIFT_FAILURE = "UPDATE_SHIFT_FAILURE";

export const DELETE_SHIFT = "DELETE_SHIFT";
export const DELETE_SHIFT_SUCCESS = "DELETE_SHIFT_SUCCESS";
export const DELETE_SHIFT_FAILURE = "DELETE_SHIFT_FAILURE";
